import React, {useState} from 'react';
import {changePassword} from "../../http/userAPI";

const ChangePasswordForm = () => {
    const [newPasswordRequest, setNewPasswordRequest] = useState({
        oldPassword: '',
        newPassword: '',
        newPasswordConfirmation: ''
    })
    const [errorApi, setErrorApi] = useState(null)
    const [errorConfirmation, setErrorConfirmation] = useState(null)

    const sendNewPassword = () => {
        if (newPasswordRequest.newPassword === newPasswordRequest.newPasswordConfirmation) {
            setErrorConfirmation(null)
            changePassword(newPasswordRequest.oldPassword, newPasswordRequest.newPassword)
                .then(response => (response !== 200) ?
                    setErrorApi('Ошибка. Проверьте правильность ввода пароля') :
                    setErrorApi(null))
                .catch(error => setErrorApi(error.message))
        } else {
            setErrorConfirmation('Пароли не совпадают')
        }
    }

    return (
        <div className="lut-card flex flex-col gap-4">
            <h2 className="text-lg font-semibold text-bark-900">Изменить пароль</h2>
            <div className="flex flex-col gap-4">
                <div>
                    <label className="lut-label">Старый пароль</label>
                    <input
                        type="password"
                        className={`lut-input ${errorApi ? 'lut-input-error' : ''}`}
                        value={newPasswordRequest.oldPassword}
                        onChange={e =>
                            setNewPasswordRequest({...newPasswordRequest, oldPassword: e.target.value})}
                    />
                    {errorApi && <p className="mt-1 text-sm text-red-600">{errorApi}</p>}
                </div>
                <div>
                    <label className="lut-label">Новый пароль</label>
                    <input
                        type="password"
                        className={`lut-input ${errorConfirmation ? 'lut-input-error' : ''}`}
                        value={newPasswordRequest.newPassword}
                        onChange={e =>
                            setNewPasswordRequest({...newPasswordRequest, newPassword: e.target.value})}
                    />
                    {errorConfirmation && <p className="mt-1 text-sm text-red-600">{errorConfirmation}</p>}
                </div>
                <div>
                    <label className="lut-label">Подтвердите новый пароль</label>
                    <input
                        type="password"
                        className="lut-input"
                        value={newPasswordRequest.newPasswordConfirmation}
                        onChange={e =>
                            setNewPasswordRequest({...newPasswordRequest, newPasswordConfirmation: e.target.value})}
                    />
                </div>
                <button type="button" onClick={sendNewPassword} className="lut-btn-pine w-fit">
                    Изменить
                </button>
            </div>
        </div>
    );
};

export default ChangePasswordForm;
